<template>
<SessionTimeoutDialog
      v-model="showDialog"
      @confirmLogout="handleLogout"
    />
  <router-view />
</template>

<script setup>
import { ref, onMounted } from 'vue'
import SessionTimeoutDialog from './components/AUTH/SessionTimeoutDialog.vue'
import { useRouter } from 'vue-router'

const showDialog = ref(false)
const router = useRouter()

onMounted(() => {
  window.addEventListener('session-timeout', () => {
    showDialog.value = true
  })
})

function handleLogout() {
  localStorage.removeItem('token')
  router.push('/login')
}
</script>

<style>
  @import "styles/font.scss";
  @import "styles/main.scss";
</style>
